export default function ChatStatusIndicator({ status }) {
    return (
      <div className="flex justify-center">
        <div className="flex flex-row items-center text-pink-300">
          {/* You can replace the icon with a simple "..." or any character */}
          <div className="m-2 animate-spin">●</div> {/* A spinning dot */}
          <div>{status}</div>
        </div>
      </div>
    );
  }
  